import React from "react";

const LoaderComponent = () => {
  const loaderStyle = {
    width: "fit-content",
    fontWeight: "bold",
    fontFamily: "monospace",
    fontSize: "15px",
    background: "radial-gradient(circle closest-side, #ff007f 94%, transparent) right/calc(200% - 1em) 100%",
    animation: "l24 0.5s infinite alternate linear",
  };

  const loaderBeforeStyle = {
    content: '"Loading..."',
    lineHeight: "1em",
    color: "transparent",
    background: "inherit",
    backgroundImage: "radial-gradient(circle closest-side, #fff 94%, #ff007f)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
  };

  return (
    <div style={loaderStyle}>
      <span style={loaderBeforeStyle}>Loading...</span>
      <style>
        {`
          @keyframes l24 {
            100% { background-position: left; }
          }
        `}
      </style>
    </div>
  );
};

export default LoaderComponent;
